import { routes } from './routes';
import
{
  ManageAccountsOutlined,
  SourceOutlined,
  PaymentsOutlined,
  HowToRegOutlined,
  SupervisedUserCircleOutlined,
  AnalyticsOutlined,
  TrendingUpOutlined,
  AssignmentIndOutlined,
  // ExtensionOutlined,
  // SchoolOutlined,
  ChangeCircle,
  Settings,
  Lock
} from '@mui/icons-material';
import { ReactComponent as HomeIcon } from '../assets/svgs/home-icon.svg';
import { ReactComponent as AdminIcon } from '../assets/svgs/admin-icon.svg';
import { ReactComponent as DrillIcon } from '../assets/svgs/drill-builder-icon.svg';
import { ReactComponent as AnalyticsIcon } from '../assets/svgs/analytics-icon.svg';
import { ReactComponent as IndexLogo } from '../assets/svgs/index-logo.svg';
// import { ReactComponent as RezzilPlayerLogo } from '../assets/svgs/rezzil-player-logo.svg';
import RezzilPlayerLogo from '../assets/images/rezzil-player-logo.png'

import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';

export const mainNavLinks = [
  {
    id: 'home',
    icon: <HomeIcon />,
    name: 'Home',
    route: routes.home,
    isExternal: false,
    licence: [],
    role: [],
  },
  {
    id: 'admin',
    icon: <AdminIcon />,
    name: 'Admin',
    route: routes.adminAccount,
    licence: [],
    role: [],
    isExternal: false,
  },
  /*  {
     id: 'drillBuilder',
     icon: <DrillIcon />,
     name: 'Drill Builder',
     route: 'https://cms.mhs-services.com/drill-builder',
     isExternal: true,
   },
   {
     id: 'vrAnalysis',
     icon: <AnalyticsIcon />,
     name: 'VR Analysis',
     route: 'https://cms.mhs-services.com/analysis',
     isExternal: true,
   }, */
];

export const adminLinks = [
  {
    icon: <ManageAccountsOutlined />,
    name: 'Account',
    route: routes.adminAccount,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'CLUB_ADMIN',
      'CLUB_SUPER_ADMIN'
    ],
    isExternal: false,
  },
  {
    icon: <SourceOutlined />,
    name: 'Your Products',
    route: routes.adminProducts,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'CLUB_ADMIN',
      'CLUB_SUPER_ADMIN'
    ],
    isExternal: false,
  },
  {
    icon: <PaymentsOutlined />,
    name: 'Bills & Payments',
    route: routes.adminBilling,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'REZZIL_TEAM_ADMIN',
      'CLUB_SUPER_ADMIN',
      'CLUB_ADMIN',
      'REP_TEAM_ADMIN',
      'REP_TEAM_MEMBER',
    ],
    isExternal: false,
  }, {
    id: 'adminClubStats',
    icon: <SupervisedUserCircleOutlined />,
    name: 'Club Stats',
    route: routes.clubStats,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'REZZIL_TEAM_ADMIN',
      'REP_TEAM_ADMIN',
      'REP_TEAM_MEMBER',
    ],
    isExternal: false,
  },
];

export const adminManageLinks = [
  {
    id: 'repManagement',
    icon: <HowToRegOutlined />,
    name: 'Rep Management',
    route: routes.repManagement,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'REP_TEAM_ADMIN',
      'REP_TEAM_MEMBER',
      'CLUB_ADMIN',
      'CLUB_SUPER_ADMIN'
    ],
    isExternal: false,
  },
  {
    id: 'repCompanyManagement',
    icon: <SupervisedUserCircleOutlined />,
    name: 'Rep Company Management',
    route: routes.repCompanyManagement,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'REP_TEAM_ADMIN',
      'CLUB_ADMIN',
      'CLUB_SUPER_ADMIN'
    ],
    isExternal: false,
  },
  {
    id: 'clubManagement',
    icon: <SupervisedUserCircleOutlined />,
    name: 'Club Management',
    route: routes.clubManagement,
    licence: [],
    role: [
      'REZZIL_SUPER_ADMIN',
      'REZZIL_TEAM_ADMIN',
      'REP_TEAM_ADMIN',
      'REP_TEAM_MEMBER',
      'CLUB_ADMIN',
      'CLUB_SUPER_ADMIN'
    ],
    isExternal: false,
  },
  // {
  //   icon: <AnalyticsOutlined/>,
  //   name: 'Revenue',
  //   route: routes.revenue,
  //   isExternal: false,
  // },
];

export const adminExpandedRoutes = [
  routes.adminAccount,
  routes.adminProducts,
  routes.adminBilling,
  routes.repManagement,
  routes.clubManagement,
  routes.repCompanyManagement,
  // routes.revenue,
];

export const indexLink = {
  icon: <IndexLogo />,
  name: 'Index Panel',
  route: routes.indexPanel,
  isExternal: false,
  licence: [],
  role: [],
};

export const indexNavLinks = [
  {
    icon: <ManageAccountsOutlined />,
    name: 'Player Profiles',
    route: routes.indexPlayerProfiles,
    licence: [],
    role: [],
    isExternal: false,
  },
  {
    icon: <TrendingUpOutlined />,
    name: 'Index Stats',
    route: routes.indexStats,
    licence: ['index_club', 'index_club_year', 'index_club_month'],
    role: [],
    isExternal: false,
  },
  {
    icon: <AnalyticsOutlined />,
    name: 'Drill Stats',
    route: routes.indexDrillStats,
    licence: ['index_club', 'index_club_year', 'index_club_month'],
    role: [],
    isExternal: false,
  },
  {
    icon: <ExtensionOutlinedIcon />,
    name: 'Add-ons',
    route: routes.indexAddOns,
    licence: [],
    role: [],
    isExternal: false,
  },
  {
    icon: <SupervisedUserCircleOutlined />,
    name: 'Club Boards',
    route: routes.indexClubLeaderBoards,
    licence: [],
    role: [],
    isExternal: false,
  },
  // {
  //   icon: <AssignmentIndOutlined/>,
  //   name: 'Global Boards',
  //   route: routes.indexGlobalLeaderBoards,
  //   isExternal: false,
  // },
  // {
  //   icon: <ExtensionOutlined/>,
  //   name: 'Add-ons',
  //   route: 'https://google.com',
  //   isExternal: true,
  // },
  // {
  //   icon: <SchoolOutlined/>,
  //   name: 'Training',
  //   route: 'https://google.com',
  //   isExternal: true,
  // },
];

export const indexExpandedRoutes = [
  routes.indexPanel,
  routes.indexLicences,
  routes.indexPlayerProfiles,
  routes.indexStats,
  routes.indexDrillStats,
  routes.indexClubLeaderBoards,
  routes.indexGlobalLeaderBoards,
];

export const rezzilPlayerLink = {
  icon: <img src={RezzilPlayerLogo} width={130} alt={'Rezzil Player Logo'} />,
  name: 'Rezzil Player',
  //  route: routes.rezzilPlayerPanel,
  route: 'https://www.meta.com/en-gb/experiences/3600836956645933/',
  isExternal: true,
  licence: [],
  role: [],
};

export const rezzilPlayerNavLinks = [
  {
    icon: <ManageAccountsOutlined />,
    name: 'Manage Users',
    route: routes.rezzilPlayerManageUsers,
    licence: [],
    role: [],
    isExternal: false,
  },
  {
    icon: <AnalyticsOutlined />,
    name: 'View Drill Stats',
    route: routes.rezzilPlayerDrillStats,
    licence: ['index_club', 'index_club_year', 'index_club_month'],
    role: [],
    isExternal: false,
  },
  {
    icon: <SupervisedUserCircleOutlined />,
    name: 'Club Boards',
    route: routes.rezzilPlayerClubLeaderBoards,
    licence: [],
    role: [],
    isExternal: false,
  },
  {
    icon: <AssignmentIndOutlined />,
    name: 'Global Boards',
    route: routes.rezzilPlayerGlobalLeaderBoards,
    licence: [],
    role: [],
    isExternal: false,
  },
];

export const rezzilPlayerExpandedRoutes = [
  routes.rezzilPlayerPanel,
  routes.rezzilPlayerManageUsers,
  routes.rezzilPlayerDrillStats,
  routes.rezzilPlayerClubLeaderBoards,
  routes.rezzilPlayerGlobalLeaderBoards,
];

export const subNavLinks = [
  {
    icon: <ChangeCircle />,
    name: 'Updates',
    route: 'https://rezzil.com/rezzil-installer',
    licence: [],
    role: [],
    isExternal: true,
  },
  {
    icon: <Settings />,
    name: 'Support',
    route: 'https://rezzil.zendesk.com/',
    licence: [],
    role: [],
    isExternal: true,
  },
  {
    icon: <Lock />,
    name: 'Log Out',
    route: routes.logout,
    licence: [],
    role: [],
  },
];
